import { render, staticRenderFns } from "./ConfigureAlert.vue?vue&type=template&id=6a1785dc&"
import script from "./ConfigureAlert.vue?vue&type=script&lang=ts&"
export * from "./ConfigureAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports